import { Component } from '@angular/core'
import { Router } from '@angular/router'
// import { TermsAgreementComponent } from '../../components/term-agreement/terms-agreement.component'
import { MessageService } from '../../components/message/message.service'
import { messageList } from '../../components/message/message-data'
import { AccountRegistrationService } from '../../services/account-registration.service'
import { ApiCatalogService } from '../../api/api-catalog.service'
import { CompanyInfo, CompanyService } from '../../services/company.service'
import { BizTermsOfServiceComponent } from '@interserve-corp/angular'

@Component({
  standalone: true,
  selector: 'app-registration-confirm',
  templateUrl: './registration-confirm.component.html',
  styleUrls: ['./registration-confirm.component.scss'],
  imports: [
    // TermsAgreementComponent,
    BizTermsOfServiceComponent,
  ],
})
export class RegistrationConfirmComponent {
  constructor(
    private router: Router,
    private messageService: MessageService,
    private accountRegistrationService: AccountRegistrationService,
    private apiCatalogService: ApiCatalogService,
    private companyService: CompanyService,
  ) {}

  sending = false
  company: CompanyInfo | null = null
  accountType: 'admin' | 'user' | null = null
  tosApiProfileId = '817ef17c-0904-47db-9585-f12c1e6c02d2'
  checkboxText = '私はこのサービス利用規約を読んだ上で、利用規約に同意します。'
  loadingButtonLabel = '会員登録中...'
  buttonLabel = '利用規約に同意して会員登録をする'
  async register(value: any) {
    if (this.sending) return

    this.sending = true

    try {
      //顧客登録・証跡保存
      const ok = await this.accountRegistrationService.registerWithTerms(value)
      const accountInfo = this.accountRegistrationService.getRegistrationData()
      this.accountType = this.accountRegistrationService.getAccountType()

      let adminReg = false

      if (this.accountType === 'admin') {
        this.company = this.companyService.SelectedCompany
        if (this.company) {
          //会社登録項目パターン取得
          const companyFieldPattern = await this.apiCatalogService.getCompanyFieldPattern()
          let payload = {
            name: this.company.organizationName,
            wbsType: 'organization',
            fieldPatternId: companyFieldPattern.nodeObjects[0].id,
            profiles: this.company,
          }
          //会社登録・顧客紐づけ
          const registeredCompanyId = await this.apiCatalogService.postCompanyAndCustomer(
            accountInfo?.customerId || '',
            payload,
          )
          //管理者登録
          if (registeredCompanyId) {
            const adminRoleReg = await this.apiCatalogService.postAdminRole(
              registeredCompanyId,
              accountInfo?.customerId || '',
            )
            if (registeredCompanyId && adminRoleReg) {
              adminReg = true
            }
          }
        }
      }

      if (!ok || (this.accountType === 'admin' && !adminReg)) {
        this.messageService.templateMessage(messageList.M00001)
        return
      }

      this.router.navigate(['/registration-success'])
    } catch (e) {
      this.messageService.templateMessage(messageList.M00001) // システムエラー
    } finally {
      this.sending = false
    }
  }
}
